import { render, staticRenderFns } from "./viewInstructions.vue.vue?vue&type=template&id=347130a3"
import script from "./viewInstructions.vue.vue?vue&type=script&lang=js"
export * from "./viewInstructions.vue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports